(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Conversation', Conversation);

    Conversation.$inject = ['$resource', 'DateUtils'];

    function Conversation($resource, DateUtils) {
        var resourceUrl = 'api/conversations/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
